export enum HeroSectionLayout {
  TextAndMedia = 'textAndMedia',
  TextOnly = 'textOnly',
  MediaOnly = 'mediaOnly',
}
